<template lang="pug">
  .contacts(v-if="content")
    .contacts__decore-left(v-if="content.imgLeft", :style="`background-image: url(${content.imgLeft});`")
    .contacts__decore-right(v-if="content.imgRight", :style="`background-image: url(${content.imgRight});`")
    .page__wr
      Bread(v-if="content.bread", :bread="content.bread")
      .contacts__top
        .contacts__left
          .contacts__title(v-if="h1") {{h1}}
          .contacts__item(v-if="content.contacts.phone")
            a.contacts__item-link.contacts__item-link--bold(:href="content.contacts.phone.link") {{content.contacts.phone.title}}
            SvgIcon.contacts__item-arrow(v-if="content.contacts.phone.items", name="arrow", width="16", height="16")
            .contacts__item-popup(v-if="content.contacts.phone.items")
              a.contacts__item-popup-link(v-for="item in content.contacts.phone.items", :href="item.link") {{item.title}}
          .contacts__item(v-if="content.contacts.time")
            SvgIcon.contacts__item-ico(name="clock", width="16", height="16")
            .contacts__item-text {{content.contacts.time}}
          .contacts__item(v-if="content.contacts.address")
            SvgIcon.contacts__item-ico(name="marker", width="16", height="16")
            .contacts__item-text {{content.contacts.address}}
          .contacts__item(v-if="content.contacts.email")
            SvgIcon.contacts__item-ico(name="mail", width="16", height="16")
            a.contacts__item-link(:href="content.contacts.email.link") {{content.contacts.email.title}}
        .contacts__map-wr
          .contacts__map.js-contacts-map
            PreloaderImage
      .contacts__bottom
        Form(v-if="content.form", :form="content.form")
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/contacts/contacts.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {YaHelpersVue} from '@/mixins/YaHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Bread from '@/components/common/bread/bread.vue';
  import PreloaderImage from '@/components/common/preloaderImage/preloaderImage.vue';
  import Form from '@/components/common/form/form.vue';

  export default {
    name: 'Contacts',

    mixins: [AjaxHelpersVue, YaHelpersVue],

    data() {
      return {
        content: null,
        isMapInit: false
      }
    },

    components: {
      SvgIcon,
      Bread,
      PreloaderImage,
      Form
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadContactsPage', params => {
        this.request(params.url);
      });

      this.$nextTick(() => {
        this.initScripts();
      });
    },

    methods: {
      request(url) {
        this.req('ContactsPage:getContactsPage', {url}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;
          }

          if(this.checkProperty(res.content.initMapConfig)) {
            this.$nextTick(() => {
              if(!this.isMapInit) {
                this.initMapLocal('.js-contacts-map', res.content.initMapConfig);
              }
            })
          }
        }, 'contacts');
      },

      initScripts() {
        $(document).on('click', '.contacts__item-arrow', function() {
          $('.contacts__item-popup').toggleClass('contacts__item-popup--show');
          $('.contacts__item-arrow').toggleClass('contacts__item-arrow--rotate');
        });

        $(document).on('click', function(e) {
          if(!$(e.target).is('.contacts__item, .contacts__item *')) {
            $('.contacts__item-popup').removeClass('contacts__item-popup--show');
            $('.contacts__item-arrow').removeClass('contacts__item-arrow--rotate');
          }
        });
      },

      initMapLocal(block, initMapConfig) {
        EventBus.$emit('preloaderShow', 'contacts');

        this
          .initMap(block, initMapConfig)
          // Когда карта загружена
          .then(() => {
            // Добавляем на карту placemarks
            this.addAllPlacemarks(initMapConfig.coords).then(() => {

              setTimeout(() => {
                EventBus.$emit('preloaderHide', 'contacts');
              }, 750);
            });

            this.isMapInit = true;
          });
      },
    }
  }
</script>
